import React, { useEffect, useState } from "react";
import styles from "./styles/FutureText.module.css";

interface FutureProps {
  title: string;
  fontSize: string;
  imageArr?: string[];
}

const FutureText: React.FC<FutureProps> = ({
  imageArr = [],
  title,
  fontSize,
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex + 1 >= imageArr.length ? 0 : prevIndex + 1,
      );
    }, 2000); // Change image every 2 seconds

    return () => clearInterval(interval);
  }, [imageArr]);

  return (
    <span
      className={styles.futureText}
      style={{
        backgroundImage: `url(${imageArr[currentImageIndex]})`,
        transition: "background-image 1s ease-in-out",
        fontSize: fontSize,
      }}
    >
      {title}
    </span>
  );
};

export default FutureText;
